import moment from 'moment-jalali';

const fromNow = (date) => {
  moment.loadPersian();
  return moment(date).from(moment());
};

const getHour = (date) => moment(date).format('HH:mm');

const secondsToClock = (seconds) => {
  let minutes = Math.floor(seconds / 60);
  seconds = seconds % 60;
  minutes = minutes % 60;

  const pad = (num) => {
    return ('0' + num).slice(-2);
  };

  return `${pad(minutes)}:${pad(seconds)}`;
};

const getExactDateAndTime = (date) =>
  `${getHour(date)} ,${moment(date).format('jYYYY/jM/jD')}`;

const getDate = (date) => `${moment(date).format('jYYYY/jM/jD')}`;

const getFullDate = (date) => `${moment(date).format('HH:mm - jYYYY/jMM/jDD')}`;

const formatDate = (date, formatter, format) => {
  // if (language.name === 'fa') {
  moment.loadPersian();
  return moment(date, format).locale('fa').format(formatter);
  // } else {
  //   return moment(date, format)
  //     .locale('en')
  //     .format(formatter);
  // }
};

const dateHourMonthName = (date) => {
  const format = `jDD jMMMM jYYYY | H:mm`;
  if (moment(date).isValid()) return formatDate(date, format);
  return formatDate(moment(), format);
};

const jMoment = {
  fromNow,
  getHour,
  secondsToClock,
  getDate,
  getExactDateAndTime,
  dateHourMonthName,
  formatDate,
  getFullDate,
};

export { jMoment };
